import styled, {css} from 'styled-components';

import {mixins} from '../styles';

export const Table = styled.div`
  width: 100%;
`;

type TTrProps = {
  isCenter?: boolean;
};

export const Tr = styled.div<TTrProps>`
  display: flex;
  ${({theme, isCenter = true}) => css`
    align-items: ${isCenter ? 'center' : 'normal'};
    border-bottom: 1px solid ${theme.palette.grey100};
  `}
`;

export type TTdProps = TTheme & {
  align?: 'left' | 'center' | 'right';
  bold?: boolean;
  width?: string;
};

export type TThProps = TTdProps & {
  sortDirection?: string;
  sortable?: boolean;
};

const getCellStyle = ({align = 'left', bold = false, theme}: TTdProps) => css`
  padding: ${theme.spacing.s4} ${theme.spacing.s2};
  text-align: ${align};
  font-weight: ${bold ? '500' : '400'};
  word-break: break-word;
`;

const getThJustifyContent = (align: TThProps['align']) => {
  switch (align) {
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
    default:
    case 'left':
      return 'flex-start';
  }
};

const getThStyle = ({sortDirection, sortable, align = 'left'}: TThProps) => css`
  ${mixins.flexAlign(getThJustifyContent(align), 'center')}
  cursor: ${sortDirection || sortable ? 'pointer' : 'default'};
`;

export const getTableCellWidth = (widths: string[]) => {
  let result = '';

  widths.forEach((width, index) => {
    result += `
      &:nth-child(${index + 1}) {
        width: ${width};
      }
    `;
  });

  return result;
};

export const Icon = styled.div`
  ${mixins.wh('14px')}
  flex-shrink: 0;
  margin-left: ${({theme}) => theme.spacing.s1};
`;

export const Th = styled.div<TThProps>`
  ${mixins.f2}
  line-height: 16px;
  text-transform: uppercase;
  ${getCellStyle}
  ${getThStyle}
`;

export const Td = styled.div<TTdProps>`
  ${getCellStyle}
`;
